import { useQuery } from "@tanstack/react-query";
import { getGroups } from "../../../services/emailGroupServices";
import EmailGroupManager from "../../../components/admin/messages/EmailGroupManager";

export default function EmailGroups() {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["groups"],
    queryFn: getGroups,
    retry: false,
  });

  if (isError) {
    return (
      <div>
        <p className="text-red-500">
          Error: {error?.message || "Failed to fetch groups"}
        </p>
        <button onClick={() => refetch()}>Retry</button>
      </div>
    );
  }

  return <EmailGroupManager users={data?.data ?? []} refreshGroups={refetch} />;
}
